export enum PriceTypeEnum {
  TOTAL = "TOTAL",
  CHARGEABLE_WEIGHT = "CHARGEABLE_WEIGHT",
}
